import React from 'react';

import {
  Dialog,
  DialogContent,
  DialogTitle
} from '@mui/material';



export interface IProps {
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  return (
    <Dialog
      open
      onClose={props.onClose}>
      <DialogTitle>
        Contact Us
      </DialogTitle>

      <DialogContent>
        Email our support staff with any questions or inquiries at <a href="mailto: support@raisewithridge.com">
          support@raisewithridge.com
        </a>.
        Please enter the details of your request and a member of our support staff will respond as soon as possible.
      </DialogContent>
    </Dialog>
  );
};
